// services/notificationChannels.js
// Shared "is this notify-on-completion channel connected?" check, used by
// IntegrationsPage.jsx's own connected-state grid and by the agent
// notify-on-completion gating (RuntimeConfigPanel, AddTaskModal). Keeps the
// gmail/telegram connection logic in one place instead of duplicating it.

import { gmailAPI, API_ORIGIN } from "./api";

export const CHANNEL_LABELS = { email: "Email", telegram: "Telegram", whatsapp: "WhatsApp" };

async function isGmailConnected() {
  try {
    const d = await gmailAPI.status();
    return !!d?.connected;
  } catch {
    return false;
  }
}

async function isTelegramConnected() {
  const token = localStorage.getItem("authToken") || localStorage.getItem("token");
  if (!token) return false;
  try {
    const r = await fetch(`${API_ORIGIN}/telegram/status`, { headers: { Authorization: `Bearer ${token}` } });
    const d = r.ok && (r.headers.get("content-type") || "").includes("json") ? await r.json() : null;
    return !!d?.connected;
  } catch {
    return false;
  }
}

async function isWhatsAppConnected() {
  const token = localStorage.getItem("authToken") || localStorage.getItem("token");
  if (!token) return false;
  try {
    const r = await fetch(`${API_ORIGIN}/whatsapp/link/status`, { headers: { Authorization: `Bearer ${token}` } });
    const d = r.ok && (r.headers.get("content-type") || "").includes("json") ? await r.json() : null;
    return !!d?.linked;
  } catch {
    return false;
  }
}

/** @param {"email"|"telegram"|"whatsapp"} channel */
export async function isChannelConnected(channel) {
  if (channel === "email") return isGmailConnected();
  if (channel === "telegram") return isTelegramConnected();
  if (channel === "whatsapp") return isWhatsAppConnected();
  return false;
}
